import { createContext, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uniqueId } from "lodash";

import { useMapContext } from "../MapContext";
import { getDisplayName } from "../../Utils/getDisplayName";

import { initializeMapPanel, openMapPanel } from "../../../reducers/map/panels";

export const MapPanelContext = createContext({});

export default function withMapPanelWrapper(WrappedComponent) {
  const WithMapPanelWrapper = props => {
    const { isOpen } = props;

    const idRef = useRef(props.id || uniqueId("MapPanel:"));
    const id = idRef.current;
    const { mapKey } = useMapContext();

    const dispatch = useDispatch();

    const registeredPanel = useSelector(({ map }) => map[mapKey].panels.activePanels[id]);

    useEffect(() => {
      dispatch(initializeMapPanel(mapKey, id));
    }, [dispatch, id, mapKey]);

    useEffect(() => {
      if (isOpen) dispatch(openMapPanel(mapKey, id));
    }, [dispatch, id, isOpen, mapKey]);

    if (!registeredPanel) return null;

    return (
      <MapPanelContext.Provider value={{ id }}>
        <WrappedComponent {...{ ...props, id }} />
      </MapPanelContext.Provider>
    );
  };

  WithMapPanelWrapper.displayName = `WithMapPanelWrapper(${getDisplayName(
    WrappedComponent
  )})`;

  return WithMapPanelWrapper;
}
